export enum META_MENU_ROUTES {
	PRESENTER_SETTINGS = 'presenter_settings',
	EVENT_SETTINGS = 'event_settings',
	PROFILE = 'profile',
	PROFILE_EDIT = 'profile_edit', // for editing others profiles
	ALL_NOTES = 'all_notes',
	SHARING = 'sharing_is_caring',
	EFFECTS = 'effects',
	NONE = 'none',
	STYLE_PACK_INFO = 'style-pack-info',
	STYLE_PACKS = 'style-packs',
	SRT = 'srt',
	ONSITE_LOCATION = 'onsite-location',
}

export const META_MENU_STATES = {
	OPEN: 'open',
	OPENING: 'opening',
	CLOSING: 'closing',
	CLOSED: 'closed',
};

export enum MetaMenuOptions {
	Info = 'Info',
	Streaming = 'Streaming',
	Settings = 'Settings',
}

export enum TABS {
	NONE = 'none',
	// video/screenshare/invite thumbnails
	FEEDS = 'feeds',
	// greenroom's internal chat rooms
	CHAT = 'chat',
	// design "settings" for the room - spacing, layout, etc
	SETTINGS = 'settings',
	// overlays, recordings, files
	MEDIA = 'media',
	// I believe USER is unused, it's for the profile in the meta menu, I think
	USER = 'user',
	// shot drawer
	SHOTS = 'shots',
	// both room notes and teleprompter notes
	NOTES_TELEPROMPTER = 'notes-teleprompter',
	// editing animations for an overlay
	OVERLAYS = 'overlays',
	// I believe unused
	TITLES = 'titles',
	// for the audience_tab feature
	AUDIENCE = 'audience',
	// editing generated content styles/animations
	GENERATE_MEDIA_CONTENT = 'generate-media-content',
	// audio settings
	AUDIO_SETTINGS = 'audio-settings',
}

// these are part of the "settings" tab and so for functionality,
// they are sometimes considered the same tab as settings
export const SUB_TABS = [
	TABS.GENERATE_MEDIA_CONTENT,
	TABS.OVERLAYS,
];
export const SUB_TABS_MAP: Record<string, true> = {
	[TABS.GENERATE_MEDIA_CONTENT]: true,
	[TABS.OVERLAYS]: true
}

export const SHOT_MODAL_TABS = {
	FEEDS: TABS.FEEDS,
	MEDIA: TABS.MEDIA,
};
